import { render, staticRenderFns } from "./pgcQaDetail.vue?vue&type=template&id=4bf3f8b3&scoped=true"
import script from "./pgcQaDetail.vue?vue&type=script&lang=js"
export * from "./pgcQaDetail.vue?vue&type=script&lang=js"
import style0 from "./pgcQaDetail.vue?vue&type=style&index=0&id=4bf3f8b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf3f8b3",
  null
  
)

export default component.exports